module.exports = __webpack_public_path__ + "img/1.476da84e.png";